import { useQuery } from 'react-query';
import QUERY_CACHE_KEY from '@src/constants/QueryCacheKey';

function usePostHeartsQuery(postId, options) {
  return useQuery(QUERY_CACHE_KEY.postHearts(postId), options);
}

export default usePostHeartsQuery;
